import dayjs from "dayjs";

// ========== Formart money ==========
// Định dạng số tiền với đơn vị đ: dùng dấu "." phân tách hàng nghìn
export const formatCurrency = (value) => {
  if (!value) {
    return new Intl.NumberFormat("vi-VN", {
      style: "currency",
      currency: "VND",
    }).format(0);
  }
  return new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

// Định dạng số tiền với đơn vị VNĐ: dùng dấu "." phân tách hàng nghìn
export const formatCurrencyWithUnit = (amount, unit = "VND") => {
  if (!amount || amount === 0) return `0 ${unit}`;
  return `${formatAmount(amount)} ${unit}`;
};

// Định dạng số tiền: dùng dấu "." phân tách hàng nghìn, dấu "," phân tách thập phân
export const formatAmount = (amount) => {
  if (!amount || amount === 0) return "0";
  return new Intl.NumberFormat("vi-VN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

// ========== Formart date, time ==========
// Định dạng ngày: hiển thị ngày theo định dạng DD/MM/YYYY
export const formatDate = (dateString) => {
  if (!dateString) return "Chưa xác định";
  const date = dayjs(dateString);
  return date.isValid() ? date.format("DD/MM/YYYY") : "Chưa xác định";
};

// Định dạng giờ: hiển thị giờ theo định dạng HH:mm
// export const formatTime = (dateString) => {
//   if (!dateString) return "--:--";
//   const date = new Date(dateString);
//   return date.toLocaleTimeString("vi-VN", {
//     hour: "2-digit",
//     minute: "2-digit",
//     second: "2-digit",
//     hour12: false,
//   });
// };

// // Định dạng giờ: hiển thị giờ theo định dạng HH:mm
export const formatTime = (dateString) => {
  if (!dateString) return "--:--:--";
  const date = dayjs(dateString);
  return date.isValid() ? date.format("HH:mm:ss") : "--:--:--";
};

// Định dạng ngày giờ: hiển thị đầy đủ ngày và giờ dạng DD/MM/YYYY HH:mm:ss
// export const formatDateTime = (dateString) => {
//   if (!dateString) return "Chưa xác định";
//   const date = new Date(dateString);
//   return new Intl.DateTimeFormat("vi-VN", {
//     year: "numeric",
//     month: "2-digit",
//     day: "2-digit",
//     hour: "2-digit",
//     minute: "2-digit",
//     second: "2-digit",
//     hour12: false,
//   }).format(date);
// };

// Định dạng ngày giờ: hiển thị đầy đủ ngày và giờ dạng DD/MM/YYYY HH:mm:ss
export const formatDateTime = (dateString) => {
  if (!dateString) return "Chưa xác định";
  const date = dayjs(dateString);
  return date.isValid() ? date.format("DD/MM/YYYY HH:mm:ss") : "Chưa xác định";
};

const padDatePart = (value) => String(value).padStart(2, "0");

const isValidDate = (date) => date instanceof Date && !Number.isNaN(date.getTime());

// Format date for date inputs and date-only API payloads: YYYY-MM-DD
export const formatInputDate = (value) => {
  if (!value) return "";

  if (value && typeof value.format === "function") {
    return value.isValid?.() === false ? "" : value.format("YYYY-MM-DD");
  }

  if (typeof value === "string") {
    const dateOnlyMatch = value.match(/^\d{4}-\d{2}-\d{2}/);
    if (dateOnlyMatch) return dateOnlyMatch[0];
  }

  const date = value instanceof Date ? value : new Date(value);
  if (!isValidDate(date)) return "";

  return [
    date.getFullYear(),
    padDatePart(date.getMonth() + 1),
    padDatePart(date.getDate()),
  ].join("-");
};

// Format date-time for date-time inputs and API payloads without timezone conversion: YYYY-MM-DDTHH:mm:ss
export const formatInputDateTime = (value) => {
  if (!value) return null;

  if (value && typeof value.format === "function") {
    return value.isValid?.() === false ? null : value.format("YYYY-MM-DDTHH:mm:ss");
  }

  const date = value instanceof Date ? value : new Date(value);
  if (!isValidDate(date)) return null;

  const datePart = [
    date.getFullYear(),
    padDatePart(date.getMonth() + 1),
    padDatePart(date.getDate()),
  ].join("-");

  const timePart = [
    padDatePart(date.getHours()),
    padDatePart(date.getMinutes()),
    padDatePart(date.getSeconds()),
  ].join(":");

  return `${datePart}T${timePart}`;
};

// ========== Formart quantity ==========
// Định dạng số lượng: dùng dấu "," phân tách thập phân, hiển thị tối đa 4 chữ số thập phân
export const formatQuantity = (quantity) => {
  if (!quantity || quantity === 0) return "0";
  return new Intl.NumberFormat("vi-VN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 4,
  }).format(quantity);
};

// ========== Formart number ==========
export const formatNumber = (num, maxFractionDigits = 0) => {
  if (num == null || Number.isNaN(num)) return "-";

  if (maxFractionDigits === 0) {
    return new Intl.NumberFormat("vi-VN").format(Math.round(num));
  }

  return new Intl.NumberFormat("vi-VN", {
    minimumFractionDigits: maxFractionDigits,
    maximumFractionDigits: maxFractionDigits,
  }).format(num);
};
